module.exports = __webpack_public_path__ + "static/img/20201215085427_60849.84e6482.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20201215085427_60849.png
// module id = Lih3
// module chunks = 73